import React, { useEffect, useState, useRef } from 'react';
import { Input } from 'reactstrap';
import SelectTopic from './SelectTopic';
import firebase from 'firebase';

const SubjectTopicWeightage = ({
  loopData,
  quizData,
  setQuizData,
  setError,
}) => {
  const [topicQuestionCounts, setTopicQuestionCounts] = useState({});
  const [isLoadingCounts, setIsLoadingCounts] = useState(false);
  const fetchedSubjectsRef = useRef(new Set());
  const db = firebase.firestore();

  // Fetch question counts for all topics
  useEffect(() => {
    const fetchQuestionCounts = async () => {
      // Check if there are any new subjects to fetch
      const newSubjects = loopData.filter(
        item => !fetchedSubjectsRef.current.has(item.subjectId)
      );

      // console.log('newSubjects', newSubjects);
      
      if (newSubjects.length === 0) {
        return; // No new subjects to fetch
      }
      
      // Show loading indicator only for initial fetch
      const loadingIndicator = document.querySelector('#loading-indicator');
      if (loadingIndicator) loadingIndicator.style.display = 'flex';
      setIsLoadingCounts(true);
      
      const counts = { ...topicQuestionCounts };

      console.log('topicQuestionCounts', topicQuestionCounts);
      
      for (const item of newSubjects) {
        for (const topic of item.topics) {
          const key = `${item.subjectName}_${topic.name}`;

          console.log("itemSSSubject", item.subjectName, topic.name);
          
          try {
            const snapshot = await db
              .collection('QuestionsV2')
              .where('subject', '==', item.subjectName)
              .where('topic', '==', topic.name)
              .where('status', '==', 0)
              .get();
            
            counts[key] = snapshot.size;
          } catch (error) {
            console.error(`Error fetching count for ${key}:`, error);
            counts[key] = 0;
          }
        }
        
        // Mark this subject as fetched
        fetchedSubjectsRef.current.add(item.subjectId);
      }
      
      setTopicQuestionCounts(counts);
      
      // Hide loading indicator
      if (loadingIndicator) loadingIndicator.style.display = 'none';
      setIsLoadingCounts(false);
    };

    if (loopData && loopData.length > 0) {
      fetchQuestionCounts();
    }
  }, [loopData]);
  const handleEqual = (checked, item) => {
    setQuizData({
      ...JSON?.parse(JSON?.stringify(quizData)),

      subjectWeitage: quizData?.subjectWeitage?.map((sw) => {
        if (item?.subjectId === sw?.subjectId) {
          return {
            ...JSON?.parse(JSON?.stringify(sw)),
            isEqual: checked,
            selectedTopics: [],
            totalWeitagePercentage: 0,
          };
        } else return sw;
      }),
    });
  };

  const handleTopicSelect = (checked, item, topic) => {
    if (checked) {
      setQuizData({
        ...JSON?.parse(JSON?.stringify(quizData)),

        subjectWeitage: quizData?.subjectWeitage?.map((sw) => {
          if (item?.subjectId === sw?.subjectId) {
            return {
              ...JSON?.parse(JSON?.stringify(sw)),

              selectedTopics: [...sw?.selectedTopics, topic],
            };
          } else return sw;
        }),
      });
    } else {
      setQuizData({
        ...JSON?.parse(JSON?.stringify(quizData)),

        subjectWeitage: quizData?.subjectWeitage?.map((sw) => {
          return {
            ...JSON?.parse(JSON?.stringify(sw)),
            selectedTopics: sw?.selectedTopics?.filter(
              (data) => data?.name !== topic?.name
            ),
          };
        }),
      });
    }
  };

  const handleEqualTopicSelect = (item) => {
    if (item?.isEqual) {
      let remaining = item?.questionPerSub;
      let each = Math.floor(
        item?.questionPerSub / item?.selectedTopics?.length
      );
      let topics = item?.selectedTopics?.map((topic, i) => {
        console.log('topic21', topic);
        if (i !== item?.selectedTopics?.length - 1) {
          remaining = remaining - each;
        }
        return {
          ...topic,
          noOfQuestion:
            i !== item?.selectedTopics?.length - 1 ? each : remaining,
          percentageOfQuestion:
            ((i !== item?.selectedTopics?.length - 1 ? each : remaining) /
              item?.questionPerSub) *
            100,
        };
      });
      setQuizData({
        ...JSON?.parse(JSON?.stringify(quizData)),

        subjectWeitage: quizData?.subjectWeitage?.map((sw) => {
          if (item?.subjectId === sw?.subjectId) {
            return {
              ...JSON?.parse(JSON?.stringify(sw)),
              selectedTopics: topics,
              totalWeitagePercentage:
                item?.isEqual && item?.selectedTopics?.length ? 100 : 0,
            };
          } else return sw;
        }),
      });
    }
    // else {
    //   setQuizData({
    //     ...JSON?.parse(JSON?.stringify(quizData)),

    //     subjectWeitage: quizData?.subjectWeitage?.map((sw) => {
    //       return {
    //         ...JSON?.parse(JSON?.stringify(sw)),
    //         isEqual: false,
    //         topics: item?.topics?.map((topic, i) => {
    //           return {
    //             ...topic,
    //             noOfQuestion: '',
    //           };
    //         }),
    //       };
    //     }),
    //   });
    // }
  };

  const handleManualPercentageOnTopicChange = (item) => {
    let totalPercentage = 0;
    item?.selectedTopics?.map((topic) => {
      totalPercentage += topic?.percentageOfQuestion
        ? +topic?.percentageOfQuestion
        : 0;
    });
    setQuizData({
      ...JSON?.parse(JSON?.stringify(quizData)),

      subjectWeitage: quizData?.subjectWeitage?.map((sw) => {
        if (item?.subjectId === sw?.subjectId) {
          return {
            ...JSON?.parse(JSON?.stringify(sw)),
            totalWeitagePercentage: totalPercentage,
          };
        } else return sw;
      }),
    });
  };

  const handleManualTopicPercentage = (
    item,
    currentTopicPercentage,
    currentTopic
  ) => {
    // Allow 0 to clear the field without error
    if (currentTopicPercentage === 0) {
      // Reset the topic's percentage to 0
      let totalPercentage = 0;
      let topics = item?.selectedTopics?.map((topic, i) => {
        if (topic?.name === currentTopic?.name) {
          return {
            ...topic,
            noOfQuestion: 0,
            percentageOfQuestion: 0,
          };
        } else {
          totalPercentage = totalPercentage + (+topic?.percentageOfQuestion || 0);
          return topic;
        }
      });
      
      setQuizData({
        ...JSON?.parse(JSON?.stringify(quizData)),
        subjectWeitage: quizData?.subjectWeitage?.map((sw) => {
          if (item?.subjectId === sw?.subjectId) {
            return {
              ...JSON?.parse(JSON?.stringify(sw)),
              selectedTopics: topics,
              totalWeitagePercentage: totalPercentage,
            };
          } else return sw;
        }),
      });
      return;
    }
    
    if (currentTopicPercentage > 0 && currentTopicPercentage <= 100) {
      let remaining = +item?.questionPerSub;
      let totalPercentage = 0;
      let each = Math.floor(
        (+item?.questionPerSub * currentTopicPercentage) / 100
      );
      let topics = item?.selectedTopics?.map((topic, i) => {
        if (topic?.name === currentTopic?.name) {
          totalPercentage += currentTopicPercentage;

          if (totalPercentage < 100) {
            remaining -= each;
          }
          // debugger;

          return {
            ...topic,
            noOfQuestion: totalPercentage === 100 ? remaining : each,
            percentageOfQuestion: currentTopicPercentage,
          };
        } else {
          remaining = remaining - (+topic?.noOfQuestion || 0);
          totalPercentage =
            totalPercentage + (+topic?.percentageOfQuestion || 0);
          return topic;
        }
      });
      if (totalPercentage <= 100) {
        setQuizData({
          ...JSON?.parse(JSON?.stringify(quizData)),

          subjectWeitage: quizData?.subjectWeitage?.map((sw) => {
            if (item?.subjectId === sw?.subjectId) {
              return {
                ...JSON?.parse(JSON?.stringify(sw)),
                selectedTopics: topics,
                totalWeitagePercentage: totalPercentage,
              };
            } else return sw;
          }),
        });
      } else {
        setError('Total Percentage Can Not be More Then 100');
        setQuizData({
          ...JSON?.parse(JSON?.stringify(quizData)),

          subjectWeitage: quizData?.subjectWeitage?.map((sw) => {
            if (item?.subjectId === sw?.subjectId) {
              return {
                ...JSON?.parse(JSON?.stringify(sw)),
                totalWeitagePercentage: totalPercentage,
              };
            } else return sw;
          }),
        });
      }
    } else if (currentTopicPercentage < 0) {
      setError('Not A Valid Percentage');
    } else if (currentTopicPercentage > 100) {
      setError('Not A Valid Percentage');
    }
  };

  const inputStyle = {
    backgroundColor: '#2c2f47',
    color: '#fff',
    border: '1px solid #5a5e75',
    width: '80px',
    display: 'block',
  };
  console.log(quizData, 'loop');
  return (
    <div>
      {loopData?.map((item) => (
        <div style={{ marginBottom: '20px' }} key={item?.id}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              color: 'white',
              padding: '12px 0 12px 0',
              borderBottom: '1px solid rgba(255,255,255,0.2)',
            }}
          >
            <div style={{ display: 'flex', gap: '6px' }}>
              <p style={{ color: 'white', fontWeight: 'bold' }}>
                Total questions from {item?.subjectName} ({Object.keys(topicQuestionCounts)
                  .filter(key => key.startsWith(`${item?.subjectName}_`))
                  .reduce((sum, key) => sum + (topicQuestionCounts[key] || 0), 0)} available)
              </p>
              <Input
                disabled={item?.isEqual || item?.totalWeitagePercentage}
                type='number'
                name=''
                // value={quizData.name}
                onChange={(e) => {
                  setQuizData({
                    ...JSON?.parse(JSON?.stringify(quizData)),
                    subjectWeitage: quizData?.subjectWeitage?.map((sw) => {
                      if (item?.subjectId === sw?.subjectId) {
                        return {
                          ...JSON?.parse(JSON?.stringify(sw)),
                          questionPerSub: e?.target?.value,
                        };
                      } else return sw;
                    }),
                  });
                }}
                style={{
                  ...inputStyle,
                  height: '30px',
                  alignItems: 'center',
                  margin: '0',
                  position: 'inherit',
                }}
                required
              />
            </div>
            <div>
              <p style={{ color: 'white' }}>
                Topic Weightage:{item?.totalWeitagePercentage}%
              </p>
              <p style={{ color: 'white' }}></p>
            </div>
          </div>
          <p style={{ color: 'white', marginTop: '6px' }}>Topics wise Weightage For  {item?.subjectName}</p>
          <div
            style={{
              margin: '10px 10px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            <Input
              disabled={!item?.questionPerSub}
              type='checkbox'
              name='name'
              id={item?.name}
              placeholder='Enter quiz name'
              // style={inputStyle}
              required
              onChange={(e) => handleEqual(e?.target?.checked, item)}
              style={{
                opacity: !item?.questionPerSub ? '.5' : '1',
                margin: '0',
                marginTop: '0',
                position: 'inherit',
              }}
            />
            <label
              htmlFor={item?.name}
              style={{ color: 'white', margin: '0', marginTop: '0' }}
            >
              Set Equal weightage
            </label>
          </div>
          <div
            style={{
              display: 'flex',
              // gap: '8px',
              flexWrap: 'wrap',
              gap: '12px',
              padding: '0 15px',
            }}
          >
            {item?.topics?.map((topic) => {
              const topicKey = `${item.subjectName}_${topic.name}`;
              const topicWithCount = {
                ...topic,
                questionCount: topicQuestionCounts[topicKey] || 0
              };
              
              return (
                <SelectTopic
                  key={topicKey}
                  item={item}
                  topic={topicWithCount}
                  handleTopicSelect={handleTopicSelect}
                  handleEqualTopicSelect={handleEqualTopicSelect}
                  handleManualTopicPercentage={handleManualTopicPercentage}
                  handleManualPercentageOnTopicChange={
                    handleManualPercentageOnTopicChange
                  }
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubjectTopicWeightage;
